const c = ({
  start_date: e,
  end_date: s,
  adults: t,
  children: n,
  promoCode: r
}) => {
  const a = {
    start_date: e,
    end_date: s,
    adults: t,
    children: n
  };
  return r && (a.promoCode = r), "?" + new URLSearchParams(a);
};
export {
  c as setQueryParams
};
